import {NavController, ViewController, AlertController, LoadingController} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {PersonMsgViewPage} from "../personMsgView/personMsgView";

@Component({
    templateUrl: 'personMsg.html',
    selector: 'person-msg-page',
})
export class PersonMsgPage {
    private recordList: any = [];
    private recordList1: any = [];
    private infiniteScrollBoolean: boolean = true;
    private infiniteScrollBoolean1: boolean = true;
    private selectAction: string = "action1";
    ntitle: string;
    nrecipient: string;
    ncontent: string;

    constructor(public loadingCtrl: LoadingController, private viewCtrl: ViewController, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService) {}

    initData() {
        this.getFirstData();
        this.getFirstData1();
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        this.userService.personMessageSearch(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.recordList = data["reslist"];
                this.recordList.map(item => {
                    item["sendtime"] = item["sendtime"].replace(/-/g, '/');
                    return item;
                });
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.personMessageSearchNext(undefined, this).then(data => {
                if (!data["msg"]) {
                    this.recordList = this.recordList.concat(data["reslist"]);
                    this.recordList.map(item => {
                        item["sendtime"] = item["sendtime"].replace(/-/g, '/');
                        return item;
                    });
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    doRefresh1(refresher) {
        this.getFirstData1(refresher);
    }

    getFirstData1(refresher: any = null) {
        this.userService.personMsgSendSearch(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.recordList1 = data["reslist"];
                this.recordList1.map(item => {
                    item["sendtime"] = item["sendtime"].replace(/-/g, '/');
                    return item;
                });
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean1 = true;
                }
            }
        });
    }

    doInfinite1(infiniteScroll) {
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.personMsgSendSearchNext(undefined, this).then(data => {
                if (!data["msg"]) {
                    this.recordList1 = this.recordList1.concat(data["reslist"]);
                    this.recordList1.map(item => {
                        item["sendtime"] = item["sendtime"].replace(/-/g, '/');
                        return item;
                    });
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean1 = false;
                }
            });
        }, 500);
    }

    goDetail(id: string) {
        this.nav.push(PersonMsgViewPage, {
            data: id
        })
    }

    deleteMsg(e: any, id: string) {
        event.stopPropagation();
        let postData = {
            id: id
        };
        this.userService.personMessageDel(postData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Xóa thành công"
                });
                this.getFirstData();
            }
        });
    }

    addUser() {
        this.nrecipient = "Đại lý cấp trên";
    }

    sendMessage() {
        let postData = {
            ntitle: this.ntitle,
            nrecipient: this.nrecipient,
            ncontent: this.ncontent
        };

        this.userService.personMessageSave(postData, this).then(data => {
            if (!data["msg"]) {
                this.ntitle = "";
                this.ncontent = "";
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: "Gửi thành công"
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillEnter() {
        this.initData();
    }
}





// WEBPACK FOOTER //
// ./src/pages/personMsg/personMsg.ts